export const environment = {
  production: false,
  api: 'http://gw-ganalottodo-dev.tcpip.tech/',
  domain: 'tcpip.tech'
};



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/environments/environment.ts